import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'nc-processing-dialog',
  templateUrl: './nc-processing-dialog.component.html',
  styleUrls: ['./nc-processing-dialog.component.scss']
})
export class NcProcessingDialogComponent {
  label: string;
  color: 'primary' | 'accent' | 'warn' = 'primary';
  mode: 'indeterminate' | 'buffer' | 'query' = 'indeterminate';

  constructor(@Inject(MAT_DIALOG_DATA) data) {
    this.label = data?.label;
  }
}
